import React, {useState} from "react"
import cogoToast from 'cogo-toast';
import NumberFormat from 'react-number-format';
import Notiflix from "notiflix";
// require("dotenv").config({
//     path: `.env.${process.env.NODE_ENV}`,
//   })

let hasSent = false;
let validForm = true;
function checkInputs (){
    var serialize = require('form-serialize');
    let user = serialize(document.querySelector('#resumoForm'), {hash:true}) ;
    if(!JSON.stringify(user.name)){
        validForm = false;
        document.getElementById('error-name').innerHTML = "* Campo obrigatório";
    }else{
        document.getElementById('error-name').innerHTML = "";
    }
    if(!JSON.stringify(user.phone)){
        validForm = false;
        document.getElementById('error-phone').innerHTML = "* Campo obrigatório";
    }else{        
        document.getElementById('error-phone').innerHTML = "";
    }
   if(!JSON.stringify(user.email)){
    validForm = false;
    document.getElementById('error-email').innerHTML = "* Campo obrigatório";
   }else if(!validateEmail(JSON.stringify(user.email))){
    validForm = false;
    document.getElementById('error-email').innerHTML = "* Por favor, insira um email válido."; 
   }else{
    document.getElementById('error-email').innerHTML = ""; 
   }
 
    function validateEmail(email) {  
        const re= /\S+@\S+\.\S+/;
        return re.test(email);
    }

    return validForm;
}

let sendEmail =  async (questoes, iconeBusiness) => {
    if(hasSent){return;}
    hasSent=true; 
    var serialize = require('form-serialize');
    let user = serialize(document.querySelector('#resumoForm'), {hash:true})

   
    let body = {questions:questoes};
    console.log(JSON.stringify(body));
    
    body.user = user;
    body.logo = iconeBusiness;
    body.businessName = "Valley Innovation"; //TO FIX --- GET NAME FROM API
    console.log(body.logo)
    console.log(process.env.API_URL)
    cogoToast.loading('A enviar email ...').then(() => {
     
    const rawResponse = fetch((process.env.API_URL || "http://localhost:1337")+'/emailfollowup', { //set link progrm.
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body:JSON.stringify(body)
    }).then((response)=>
        {           
                if(response.ok)
                {      
                    
                    Notiflix.Report.success(
                        'SUCESSO',
                        'Email enviado com sucesso!',
                        'Fechar',
                        function(){
                            window.location = '/'; 
                        },
                        {buttonFontSize:"19px",svgSize:"100px",}
                      );
                }
                else
                {
                    Notiflix.Report.failure(
                        'ERRO',
                        'Email falhou no envio!',
                        'Fechar',
                        function(){
                          // callback
                        },{buttonFontSize:"19px",svgSize:"100px",}
                      );
                    hasSent = false;
                }
        }
    );
     });


  };


const Resumo = ({questoes, respostas, contactoTitulo, contactoDescricao, backToQuestions, icone, iconeBusiness, service}) => // meter textos pelo type na api
{
    console.log(window.innerWidth)
    if(window.innerWidth > 450){
    return (
        //DESCKTOP
    <div className="resumoholder">      
    <div className="resumoDesktop">    
        <h1 className="titleResumo">Resultado da sua simulação</h1>
        <div className="uk-grid uk-grid-stack">
                <div className="resumocolumn uk-width-1-3" style={{width:"42%"}}> 
                    <div><h2 className="resumotitle">Resumo da sua simulação <span className="service">{service}</span></h2></div>
                    <div className="respostas">{respostas.map((x,i) => <div><span className="questao-number">{i+1}. </span><span className="resumoRespostas">{x.Title}</span></div>)}</div>
                    <div class="line" style={{border:"solid 0.3px var(--off-color)", backgroundColor:"var(--off-color)", margin:"20px auto 0px auto", width:"100%"}}></div>
                    <div className="orcamentoestHolder">
                        <div className="orcamentoest">Orçamento estimado</div>
                        <div className="custo">
                        <NumberFormat value={respostas.map(x => x.Cost).reduce((i1,i2) => i1+i2,0)} className="foo" displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={' €*'} renderText={(value, props) => <div {...props}>{value}</div>} />
                        </div>
                    </div>
                    <div style={{fontSize:"11px", fontFamily:"Open Sans"}}>
                    *Este valor é uma aproximação feita com base na nossa experiência de mercado e pelos trabalhos já realizados.
                    </div>
                </div>
                <div className="uk-width-1-3"  style={{width:"14%"}}></div>
                <form id="resumoForm" className="uk-width-1-3" style={{textAlign:"left", width:"44%"}}>
                    <div className="contacttitle">{contactoTitulo}</div>                    
                    <div className="contactdescription">{contactoDescricao}<p style={{marginTop:"20px"}}>Entre em contato connosco para saber mais.</p></div>
                    <input name="name" type="text" placeholder="Nome" autoComplete="off"></input>
                    <span id="error-name"  ></span>
                    <input name="phone"  type="number" placeholder="Telefone" autoComplete="off"></input>
                    <span id="error-phone"></span>
                    <input name="email" type="email" placeholder="Email" autoComplete="off"></input>
                    <span id="error-email" ></span>
                    <textarea name="addinfo" placeholder="Informações adicionais" autoComplete="off"></textarea>
                    <style>{
                    `input[type=number]::-webkit-inner-spin-button { 
                        -webkit-appearance: none;                    
                    }
                    input[type=number] { 
                    -moz-appearance: textfield;
                    appearance: textfield;
                    
                    }
                `}
                </style>
                    <button className="submitButton" style={{cursor:"pointer"}} type="button" onClick={() => {checkInputs(); if(validForm){sendEmail(respostas.map((x,i)=> {let r =x; r.Questao = questoes[i].Title; return r;}), iconeBusiness)}}}><span>ENVIAR</span></button>
                </form>
            </div>
            <div className="uk-column-1-2 uk-column-divider pag simulacaobuttons">
                <div className={'button'} onClick={backToQuestions}>QUER REVER A SUA SIMULAÇÃO?</div>
                <a className={"button"} href="/">QUER FAZER UMA NOVA SIMULAÇÃO?</a> {/* pode-se meter a limpar o state? */}
            </div>
        </div>
    </div>
    )}else{
        return(
            
            //MOBILE
            <div className="resumoholder">  
             <style>{
                    `
                    @media only screen and (max-width: 450px) {
                    
                    .toplogo img{
                        margin: 6% auto 6%;
                        width: 24%;
                    }
                    input, textarea{
                        margin-top:20px !important;
                    }
                    }
                }      
                    `}
                </style>  
             <div className="resumoMobile">
                <div className="titleResumo" style={{fontSize:"22px", fontWeight:"bold", marginBottom:"15px", fontFamily:"Ubuntu", marginTop:"9%"}}>O resultado do seu orçamento</div>
                <div className="notDivider" style={{background:"none"}}>
                      <div style={{margin:"auto 10% auto 20%"}}><img src={icone}/></div>              
                      <div className="custo" style={{fontSize:"30px"}}>
                      <NumberFormat value={respostas.map(x => x.Cost).reduce((i1,i2) => i1+i2,0)} className="foo" displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={' €*'} renderText={(value, props) => <div {...props}>{value}</div>} />
                      </div>             
                    </div>
                    <span style={{fontSize:"12px", color:"var(--off-color)"}}>* A acrescer impostos à taxa em vigor</span>
                    <div  style={{border:"solid 1px var(--off-color)", margin:"25px auto 5px auto", width:"15%", backgroundColor:"var(--off-color)"}}></div>
                    <div className="respostas">
                        {questoes.map((x,i) => 
                        <div style={{marginBottom:"5%"}}>
                            <span className="questao-number">{i+1}. </span>
                            <span style={{fontWeight: "bold"}}>{x.Title}</span>                   
                                <div style={{marginLeft:"8%", fontSize:"16px", fontFamily:"Open Sans"}}><span>{respostas[i].Title}</span></div>                   
                            </div>
                            )}                    
                        </div>
                        <form id="resumoForm" className="" style={{textAlign:"left", marginTop:"30%"}}>
                            <div className="" style={{textAlign:"center", fontFamily:"Open Sans",fontSize:"16px"}}>Para um orçamento mais preciso entre em contacto connosco através do seguinte formulário</div>                    
                            <input name="name" type="text" placeholder="Nome" autoComplete="off"></input>
                            <span id="error-name"  ></span>
                            <input name="phone"  type="number" placeholder="Telefone" autoComplete="off"></input>
                            <span id="error-phone"></span>
                            <input name="email" type="email" placeholder="Email" autoComplete="off"></input>
                            <span id="error-email" ></span>
                            <textarea name="addinfo" placeholder="Informações adicionais" autoComplete="off"></textarea>
                            <style>{
                            `input[type=number]::-webkit-inner-spin-button { 
                                -webkit-appearance: none;                    
                            }
                            input[type=number] { 
                            -moz-appearance: textfield;
                            appearance: textfield;
                            
                            }
                        `}
                        </style>
                            <button className="submitButton" style={{cursor:"pointer"}} type="button" onClick={() => {checkInputs(); if(validForm){sendEmail(respostas.map((x,i)=> {let r =x; r.Questao = questoes[i].Title; return r;}), iconeBusiness)}}}><span>ENVIAR</span></button>
                        </form>
                        <div className="simulacaobuttons" style={{margin:"15% auto 3%"}}>
                            <div className={'button'} onClick={backToQuestions} style={{fontSize:"14px"}}>QUER CORRIGIR O SEU ORÇAMENTO?</div>
                            <a className={"button"} href="/" style={{fontSize:"14px"}}>QUER FAZER UM NOVO ORÇAMENTO?</a> {/* pode-se meter a limpar o state? */}
                         </div>
                        <div  style={{border:"solid 1px var(--off-color)", margin:"0px auto 15%", width:"15%", backgroundColor:"var(--off-color)"}}></div>
        
                </div>
            </div>
        )
    }
}

export default Resumo